import React, {useState} from 'react';
import {Button, Col, Row} from 'react-bootstrap';
import Notify from '../../services/Notify';
import {AlertConfigurationsGroupsService} from '../../services/AlertConfigurationsGroupsService';
import ModalMessageNew from '../../component/Modal/ModalMessageNew';

class AlertGroupGridPage {
  title = "Grupo de alertas";
  exportNewPage = true;
  showPdfButton = false;
  customFilters = {friendlyName: null};
  actionsButtons = (row, reloadGrid) => {
    const [show, setShow] = useState(false);
    const deleteItem = async () => {
      try {
        await new AlertConfigurationsGroupsService().deleteGroupById(row.original.id);
        Notify.success('Grupo deletado com sucesso!');
      } catch (error) {
        Notify.error('Erro ao excluir grupo', error);
      } finally {
        setShow(false);
        reloadGrid && reloadGrid();
      }
    };
    return (
      <Row className="d-flex align-items-center justify-content-around flex-row">
        <Col md={6}>
          <Button block bsStyle="secondary" href={`#/notifications-groups/edit/${row.original.id}`}>
            Editar
          </Button>
        </Col>
        <Col md={6}>
          <Button block bsStyle="danger" onClick={() => setShow(true)}>
            Excluir
          </Button>
        </Col>
        <ModalMessageNew
          row={row}
          showModal={show}
          handleShowModal={setShow}
          title="Tem certeza que deseja excluir o grupo?"
          successButtonAction={deleteItem}
        />
      </Row>
    );
  };
  columns = [
    {
      Header: "Grupo",
      HeaderColumn: true,
      accessor: "friendlyName"
    },
    {
      Header: "Emails",
      accessor: "emails",
      Cell: (props) => {
        const {emails} = props.original;
        return emails ? emails.map(x => <p key={x.index}>{x.email}</p>) : [];
      }
    },
    {
      Header: "Ações",
      sortable: false,
      filterable: false,
      export: false,
      Cell: row => this.actionsButtons(row, this.forceReload)
    }
  ];
  endpoint = () => {
    return `alerts/v1/notifications-groups?deleted=false`;
  }
}

export {AlertGroupGridPage};



// WEBPACK FOOTER //
// ./src/pages/Groups/AlertGroupGridPage.js